import { FC, memo } from 'react'

import { CloseIconContainer, Container, StyledCloseIcon, Title } from './styles'
import { useTranslation } from '../../../../../hooks/locale'

type Props = {
    handleFilterToggle: () => void
}

const FilterModalHeader: FC<Props> = ({ handleFilterToggle }) => {
    const { t } = useTranslation()

    return (
        <Container>
            <Title>{t('sortBy')}</Title>
            <CloseIconContainer onClick={handleFilterToggle}>
                <StyledCloseIcon />
            </CloseIconContainer>
        </Container>
    )
}

export default memo(FilterModalHeader)
